import { useQuery } from '@tanstack/react-query';
import { getMIPInvestorsDataForSendModal } from '@dealstack/frontend/shared/dataExchange/services/mip-manage.service.ts';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import { InvestorBulkActionDto } from '@dealstack/shared/lib/generated';

export const useInvestorsForInviteModal = (payload: InvestorBulkActionDto) => {
	const query = useQuery({
		queryKey: [API_PATHS.MIP_INVESTOR_INVITE_INVESTORS_DATA_POST, payload],
		queryFn: ({ signal }) =>
			getMIPInvestorsDataForSendModal(
				API_PATHS.MIP_INVESTOR_INVITE_INVESTORS_DATA_POST,
				payload,
				signal
			),

		enabled: !!payload.selectedIds?.length || !!payload.filterQuery || !!payload.searchQuery,
	});

	return {
		investors: query.data?.payload?.investors ?? [],
		isLoading: query.isLoading,
	};
};
